<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
import Button from "@/components/c-button";
import moment from 'moment';
import { propertyService } from "../../../../services/reportservice/propertyservice.js";
import { propertycancelationService } from "../../../../services/propertyservice/propertycancelation.service";
import { servicehelpers } from "../../../../services/servicehelpers";

/* eslint-disable no-console */
export default {
  page: {
    title: "Property Gropu Summary Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    Button,
    Select, 
  },
  data() {
    return {
      title: "Property Gropu Summary Report",
      projectData: {},
      data: [],
      project_name: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      projects: {},
      cancelationData: [],
      dataStartDate: '',
      dataEndDate: '',
      dataProjectId: 1,
      user: JSON.parse(localStorage.getItem('user')),
    };
  },
  mounted() {
    this.loadingProjectData();
    this.loadingData();
    
  },
  methods: {
    
     
    loadingData: function() {
      
      this.fetchingStats = false;
      propertycancelationService.getList('?page=0')
        .then(response => {
          
          this.fetchingStats = true;
          this.cancelationData = response.data;
        });
    },
    loadingProjectData: function() {
      servicehelpers.getProjectData().then(response => {
        this.projectData = response;
      });
    },

    submitSearch: function() {
      let data = '?project_id='+this.dataProjectId;
      propertyService.getProperSummaryByGroup(data)
        .then(response => {
          this.data = response.data.property_group;
          this.project_name = response.data.project_name;
          this.projects = response.data.projects;
      });
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value) {
     
      let sign = '$';
      let decimal = ''; //'.00';
      if(value == 0 ){
        return `${sign}0${decimal}`;
      }
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },
    print() {
      window.print();
    },

    total(property) {
      return this.data.reduce(function (sum, item) {
        return sum + item[property];
      }, 0)
    },

    projectChanged: function(event) {

      let project = this.projectData.data.find(item => item.id === event);
      if(project) {
        this.dataProjectId = event;
        this.project_name = project.name;
      }

      // console.log(project);
    },

    getDay: function() {
      return moment().format('DD');
    },

    getMonth: function() {
      const months = ["មករា", "កុម្ភៈ", "មិនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"];
      return months[moment().format('M') - 1]; 
    },

    getYear: function() {
      return moment().format('YYYY');
    }

  },
  computed: {
    totalPrice() {
      return this.data.reduce(function (sum, item) {
        return sum + (item.total_price - item.total_sale_price)
      }, 0)
    },
    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.property.cancelation')" />
      <div class="row seach-area">
        <div class="col-sm-2">
          <Select
            :id="'project_id'"
            :text="'name'"
            @change="projectChanged" 
            :editable="true"
            :list="projectData"
            v-model="dataProjectId"
          /> 
        </div>
        <div class="col-sm-2">
          <Button v-bind:icon="'bx bx-search'"
            @click="submitSearch()" 
            v-bind:buttonType="'button'"
            v-bind:variant="'primary'"
            v-bind:title="$t('general.search')" 
          />
        </div>
      </div>
      <div id="print-area">
        <!-- <center> -->
          
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 685 009 | 098 685 009 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class="khb"><u>{{$t('report.property.cancelation')}}</u></p>
                    <!-- <p class=""><u>ប្រចាំខែ: {{this.dateFormat(date.start_date)}} - {{this.dateFormat(date.end_date)}}</u></p> -->
                    <p class="khb"><u>គម្រោង: {{this.project_name}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th rowspan="2">{{$t('general.number')}}</th>
                  <th>{{$t('general.date')}}</th>
                  <th colspan="4">{{$t('general.property')}}</th>
                  <th>{{$t('general.date')}}</th>
                  <th>{{$t('loan.amount')}}</th>
                  <th>{{$t('property.cancelation.transfer-amount')}}</th>
                  <th rowspan="2">{{$t('property.cancelation.step')}}</th>
                  <th rowspan="2">{{$t('general.description')}}</th>
                </tr>
                <tr class="thead">
                  
                  <th>{{$t('general.sell-buy')}}</th>
                  <th>{{$t('general.unit-number')}}</th>
                  <th>{{$t('general.price')}}</th>
                  <th>{{$t('general.discount')}}</th>
                  <th>{{$t('general.sale_price')}}</th>
                  <th>{{$t('general.cancel')}}</th>
                  <th>{{$t('general.cancel')}}</th>
                  <th>{{$t('property.cancelation.to-customer')}}</th>
                  

                </tr>
              <tbody>
                <tr v-for="(item, index) in cancelationData" :key="index" >
                  <td>{{index + 1}}</td>
                  <td>{{
                    item.booking_sell_date ? dateFormat(item.booking_sell_date) : (
                      item.sale_id == 0 ? dateFormat(item.booking_date) : dateFormat(item.sale_date)
                    )
                  }}</td>
                  <!-- <td>{{item.booking_sell_date}}</td> -->
                  <td>{{item.property}}</td>
                  <td style="text-align:right; padding: 5px;">{{formatCurrency(item.price)}}</td>
                  <td style="text-align:right; padding: 5px;">{{item.sale_id == 0 ? formatCurrency(item.booking_discount) : formatCurrency(item.discount)}}</td>
                  <td style="text-align:right; padding: 5px;">{{item.sale_id == 0 ? formatCurrency(item.booking_sale_price) : formatCurrency(item.sale_price)}}</td>
                  <td>{{dateFormat(item.for_date)}}</td>
                  <td style="text-align:right; padding: 5px;">{{formatCurrency(item.total)}}</td>
                  <td style="text-align:right; padding: 5px;">{{formatCurrency(item.refund_amount)}}</td>
                  <td>{{item.sale_id == 0 ? 'កក់ (Booking)' : 'លក់ (Sold)'}}</td>
                  <td style="text-align:left; padding: 5px;">{{item.notation}}</td>
                </tr>
              </tbody>
                <tr class="thead">
                  <th colspan="2">{{$t('general.total_cancelation')}}</th>
                  <th></th>
                  <th style="text-align:right; padding: 5px;">{{formatCurrency(cancelationData.reduce(function (sum, item) { return sum + (item.price)}, 0))}}</th>
                  <th style="text-align:right; padding: 5px;">{{formatCurrency(cancelationData.reduce(function (sum, item) { return sum + (item.sale_id == 0 ?item.booking_discount : item.discount)}, 0))}}</th>
                  <th style="text-align:right; padding: 5px;">{{formatCurrency(cancelationData.reduce(function (sum, item) { return sum + (item.sale_id == 0 ?item.booking_sale_price : item.sale_price)}, 0))}}</th>
                  <th></th>
                  <th style="text-align:right; padding: 5px;">{{formatCurrency(cancelationData.reduce(function (sum, item) { return sum + (item.total)}, 0))}}</th>
                  <th style="text-align:right; padding: 5px;">{{formatCurrency(cancelationData.reduce(function (sum, item) { return sum + (item.refund_amount)}, 0))}}</th>
                  <th colspan="2"></th>
                </tr>
            </table>
          
            <div class="row mt-3">
              <div class="col">
                <center>
                  <p class="khs"><span class="khm">បានពិនិត្យនិងឯកភាព</span><br><span class="khs">អគ្គនាយកក្រុមហ៊ុន</span></p>
                  <br><br>

                  <p>លី ប៊ុនហ៊ាង</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="khs"><span class="khm">បានពិនិត្យនិងឯកភាព</span><br><span class="khs">នាយកផ្នែកហិរញ្ញវត្ថុ</span></p>
                  <br><br>

                  <p>លឹម ទ្រី</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="khs"><span class="khm">បានពិនិត្យនិងឯកភាព</span><br><span class="khs">នាយកផ្នែកបច្ចេកទេស</span></p>
                  <br><br>

                  <p>សាយនី យូស៊ន់</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="khs"><span class="khm">បានពិនិត្យនិងឯកភាព</span><br><span class="khs">ប្រធានគ្រប់គ្រងទូទៅ</span></p>
                  <br><br>

                  <p></p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p class="khs">ថ្ងៃទី {{getDay()}} ខែ {{getMonth()}} ឆ្នាំ {{getYear()}}<br><span class="kks">អ្នកធ្វើរបាយការណ៍</span></p>
                  <br><br>

                  <p>{{this.user.name}}</p>
                </center>
              </div>
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>